export class LoanApplicationsProgressApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getApplicationProgress({ applicationId }) {
    return this.#http.get(
      `/api/loanApplications/${applicationId}/loanProgress?forClient=adminPanel`,
    );
  }
}
